import ActionType from 'actions/ActionType'

export default (state = {}, action) => {
  switch (action.type) {
		case ActionType.View.CHANGE_SORT_BY:
			return {
				...state,
				[action.payload.listType]: {
					sortBy: action.payload.sortBy,
					order:
						[
							'when_created',
							'scheduled',
							'opens',
							'sends',
							'clicks',
							'contact_count',
						].indexOf(action.payload.sortBy) !== -1
							? 'desc'
							: 'asc',
				},
			}
		case ActionType.View.CHANGE_SORT_ORDER:
			return {
				...state,
				[action.payload.listType]: {
					...state[action.payload.listType],
					order:
						state[action.payload.listType].order === 'asc' ? 'desc' : 'asc',
				},
			}
    case ActionType.View.SELECT_USER_ASSIGNMENT:
      return {
        ...state,
        userAssignment: action.payload,
      }
		// this should have a prop of which user's contacts are showing
		// unassigned is 'contact/a2'
		// assigned is 'account/a2/username'
    
		// to show 'assigned', there would need to be a 'list assigned'.
		// Otherwise, it would have to list every userId's contacts
		default:
			return state
	}
}
